import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { TUkExchangeRateRow } from './types';

/** Presets the date filters offer, mirroring the other tables that filter on a date column. */
const DATE_FILTER: [string | null | number, string][] = [
	[DATES_ID.TODAY, DATES.TODAY],
	[DATES_ID.YESTERDAY, DATES.YESTERDAY],
	[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
	[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
	[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
	[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
	[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
	[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
	[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
];

export const tableStructure: TTableStructure<keyof TUkExchangeRateRow>[] = [
	{
		name: 'Country',
		selector: 'country',
		show: false,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},
	{
		// Sent as a `fromCurrency` entry of `filters`, the options come from the currency_code enum.
		name: 'From Currency',
		selector: 'fromCurrency',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		// Its options are injected from the currency_code enum, like the From Currency ones.
		name: 'To Currency',
		selector: 'toCurrency',
		show: false,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Exchange Rate',
		selector: 'exchangeRate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'From Date',
		selector: 'fromDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_FILTER,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'To Date',
		selector: 'toDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_FILTER,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated',
		selector: 'updatedDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_FILTER,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
];
